import { render } from "./enrolmentClosed.vue?vue&type=template&id=0fe96d9b"
import script from "./enrolmentClosed.vue?vue&type=script&lang=js"
export * from "./enrolmentClosed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__